module.exports = __webpack_public_path__ + "/login_ui/img/bb-d19f7011998d0e6c14f89ac77e393eeb.svg";